import React from "react";
import "../Image/Image.css";
const Image = () => {
  return (
    <>
      <img src="terrace.webp" className="imgg" alt="terrace-image" />
    </>
  );
};

export default Image;
